// extracted by mini-css-extract-plugin
export default {"pageLinkCell":"PageLinksCell_pageLinkCell__1NeKU","linkContainer":"PageLinksCell_linkContainer__ydxZU","pageLink":"PageLinksCell_pageLink__cTJyf"};